<template>
    <div>
        <h1 class="mb-8 font-semibold text-base text-primary">{{ datas.question }}</h1>
        <div class="w-full">
            <div class="flex flex-row flex-wrap justify-center px-4">
                <div class="rounded-3xl border border-solid shadow-lg cursor-pointer flex items-center justify-end p-5 flex-auto m-1" v-for="(img, index) in formatedImages" :key="index">
                        <img height="150" width="200" class="h-32 mx-auto object-contain transition duration-450 ease-in-out transform hover:scale-90" :src="getWPUrl() + img.link" @click="$store.commit('setCurrentStep', img);"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getWPUrl } from '../utils'
    export default {
        props: {
            datas: Object
        },
        data() {
            return {
                formatedImages: []
            }
        },
        methods: {
            formatImage(image, cur_element) {
                this.formatedImages.push({
                    question: this.datas.question,
                    titre: this.datas.titre,
                    type: this.datas.type,
                    link: image,
                    name: cur_element.name,
                    value: cur_element.value,
                    answer: cur_element.answer,
                    notice: cur_element.notice,
                    breadcrumbLabel: cur_element.breadcrumbLabel
                })
            },
            formatImages() {
                this.datas.options.forEach( option => option.images.forEach(image => this.formatImage(image, option)))
            },
            getWPUrl
        },
        mounted(){
            this.formatImages()
        }
    }
</script>